
import { Main } from './src/main';

(import.meta as any).glob([
  './assets/**'
]);

new Main();
